<H1> Modbus<app-loader [status]="loaderStatus"></app-loader></H1>

<div *ngFor="let modbusTree of modbusRoot?.cIO_MODBUS_WORLD ; let y = index">

  <app-modbusnetworkdetails [connection]="modbusTree.Connection" > </app-modbusnetworkdetails>
  <div *ngFor="let modbusBranch of modbusTree.cIO_MODBUS_TREE ; let i = index">
    <app-modbusdetails [modbusTree]="modbusBranch" [refNumber]="i+1"></app-modbusdetails>
  </div>
</div>

